import React from "react";
import { Box, Typography, Divider, Chip, Paper } from "@mui/material";
import { Note, Person, Schedule } from "@mui/icons-material";
import { formatDateTime } from "../../../base/FormatTime";

const CompletedNotesCard = ({ completedNotes }) => {
  if (!completedNotes || completedNotes.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "8px",
            bgcolor: "#EFF8FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Note sx={{ fontSize: 18, color: "#1570EF" }} />
        </Box>
        <Typography variant="subtitle2" fontWeight={600} color="#1A1A2E">
          Completed Notes
        </Typography>
        <Chip
          label={completedNotes.length}
          size="small"
          sx={{
            height: 20,
            fontSize: "0.65rem",
            fontWeight: 600,
            bgcolor: "#F1F5F9",
            color: "#475467",
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {completedNotes.map((note, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "10px",
              border: "1px solid #E2E8F0",
              bgcolor: "#FFFFFF",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
              <Person sx={{ fontSize: 16, color: "#64748B" }} />
              <Typography variant="body2" fontWeight={600} color="#1A1A2E">
                {note.admin_name || note.candidate_name || "Unknown"}
              </Typography>
              {note.candidate_name && (
                <Chip
                  label="Carer"
                  size="small"
                  sx={{
                    height: 16,
                    fontSize: "0.5rem",
                    fontWeight: 500,
                    bgcolor: "#F1F5F9",
                    color: "#475467",
                  }}
                />
              )}
            </Box>

            <Typography
              variant="body2"
              color="#475467"
              sx={{
                pl: 4,
                py: 1,
                lineHeight: 1.6,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {note.notes || "No notes provided"}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, pl: 4, mt: 0.5 }}>
              <Schedule sx={{ fontSize: 12, color: "#94A3B8" }} />
              <Typography variant="caption" color="#94A3B8">
                {formatDateTime(note.created_at)}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default CompletedNotesCard;